export const iconFontAwesomeSecurityBuildingShield = (
	<i className="fa-solid fa-building-shield"></i>
);
